import { render, staticRenderFns } from "./RolesPermissionsDetails.vue?vue&type=template&id=2d299522&"
import script from "./RolesPermissionsDetails.vue?vue&type=script&lang=js&"
export * from "./RolesPermissionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports